module.exports = __webpack_public_path__ + "img/reload-record.577a0a47.svg";